"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _userflow = require("../../styles/userflow");
var _fadeInAndOut = _interopRequireDefault(require("../../styles/animations/fadeInAndOut"));
var _userflow2 = require("../../constants/userflow");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelRoomOffersSkeleton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
    columns = _ref.columns,
    isMobile = _ref.isMobile,
    showGallery = _ref.showGallery;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomOffersSkeleton, {
    className: className,
    isMobile: isMobile
  }, showGallery && /*#__PURE__*/_react["default"].createElement(StyledGallery, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledGalleryItem, {
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(StyledGalleryItem, {
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(StyledGalleryItem, {
    isMobile: isMobile
  })), /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    doubleWidth: !isMobile && !showGallery
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: 9
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, {
    style: {
      marginRight: 5
    }
  }), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, {
    style: {
      marginRight: 5
    }
  }), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: 21
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null), /*#__PURE__*/_react["default"].createElement(StyledSlash, null)), /*#__PURE__*/_react["default"].createElement(StyledLine, {
    style: {
      width: 138,
      marginBottom: 17
    }
  }), /*#__PURE__*/_react["default"].createElement(StyledLine, {
    style: {
      width: 118,
      marginBottom: 35
    }
  }), !isMobile && /*#__PURE__*/_react["default"].createElement(StyledLine, {
    style: {
      width: 138
    },
    color: "blue"
  })), /*#__PURE__*/_react["default"].createElement(StyledTable, {
    isMobile: isMobile
  }, Array(columns).fill(null).map(function (_, idx) {
    // центральный элемент
    var isHighlighted = Math.floor(columns / 2) === idx;
    return /*#__PURE__*/_react["default"].createElement(StyledTableColumn, {
      key: idx,
      highlight: isHighlighted,
      isMobile: isMobile
    }, /*#__PURE__*/_react["default"].createElement(StyledLine, {
      style: {
        width: 79,
        marginBottom: isHighlighted ? 31 : 45,
        marginTop: 23
      },
      color: isHighlighted ? 'blackBase' : undefined
    }), isHighlighted && /*#__PURE__*/_react["default"].createElement(StyledLine, {
      style: {
        width: 87,
        marginBottom: 13
      },
      color: "blackBase"
    }), /*#__PURE__*/_react["default"].createElement(StyledHotelOfferButton, {
      skeleton: true,
      disabled: true,
      isActive: isHighlighted
    }), /*#__PURE__*/_react["default"].createElement(StyledLine, {
      style: {
        width: 88,
        marginBottom: 13
      },
      color: isHighlighted ? 'blackBase' : undefined
    }), /*#__PURE__*/_react["default"].createElement(StyledLine, {
      style: {
        width: 88,
        marginBottom: 13
      },
      color: isHighlighted ? 'blackBase' : undefined
    }), /*#__PURE__*/_react["default"].createElement(StyledLine, {
      style: {
        width: 58,
        backgroundColor: 'var(--secondary)'
      }
    }));
  })));
});
HotelRoomOffersSkeleton.propTypes = {
  className: _propTypes["default"].string,
  columns: _propTypes["default"].number,
  isMobile: _propTypes["default"].bool,
  showGallery: _propTypes["default"].bool
};
HotelRoomOffersSkeleton.defaultProps = {
  className: '',
  columns: 5,
  isMobile: false,
  showGallery: true
};
var StyledSlash = _styledComponents["default"].span.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledSlash",
  componentId: "sc-1qzqb4d-0"
})(["width:15px;height:15px;position:relative;margin-right:-5px;display:inline-flex;::before{content:'';width:1px;height:133%;background-color:", ";transform:rotate(45deg);transform-origin:bottom;position:absolute;bottom:0;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.frenchGray;
});
var StyledHotelRoomOffersSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledHotelRoomOffersSkeleton",
  componentId: "sc-1qzqb4d-1"
})(["background-color:", ";border-radius:", ";box-shadow:", ";height:", ";display:flex;animation:", " ", "ms ease-in-out infinite;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadiusBig;
}, _userflow.boxShadow, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 'auto' : '260px';
}, _fadeInAndOut["default"], _userflow2.SKELETON_ANIMATION_DURATION, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && (0, _styledComponents.css)(["flex-direction:column;padding:5px 5px 10px;"]);
});
var StyledGallery = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledGallery",
  componentId: "sc-1qzqb4d-2"
})(["width:230px;overflow:hidden;height:calc(100% - 10px);margin:10px 10px 0 10px;", ""], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && (0, _styledComponents.css)(["display:flex;flex-direction:row;width:auto;height:170px;margin:0 -5px 10px 0;"]);
});
var StyledGalleryItem = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledGalleryItem",
  componentId: "sc-1qzqb4d-3"
})(["background-color:", ";", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.veryLightPink;
}, function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? (0, _styledComponents.css)(["height:170px;min-width:180px;margin-right:1px;"]) : (0, _styledComponents.css)(["height:230px;margin-bottom:1px;"]);
});
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledDescription",
  componentId: "sc-1qzqb4d-4"
})(["width:", ";margin:10px 10px 0 0;", ""], function (_ref10) {
  var doubleWidth = _ref10.doubleWidth;
  return doubleWidth ? '480px' : '240px';
}, function (_ref11) {
  var doubleWidth = _ref11.doubleWidth;
  return doubleWidth && 'margin-left: 10px';
});
var StyledLine = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledLine",
  componentId: "sc-1qzqb4d-5"
})(["height:1px;background-color:", ";"], function (_ref12) {
  var theme = _ref12.theme,
    color = _ref12.color;
  return theme.colors[color || 'frenchGray'];
});
var StyledTable = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledTable",
  componentId: "sc-1qzqb4d-6"
})(["display:flex;flex-direction:row;justify-content:center;overflow:hidden;position:relative;", ""], function (_ref13) {
  var isMobile = _ref13.isMobile;
  return isMobile ? (0, _styledComponents.css)(["::before,::after{content:'';position:absolute;display:block;top:0;left:0;height:100%;width:20px;background-image:linear-gradient( to left,rgba(255,255,255,0),#fff );}::after{right:0;left:auto;transform:rotate(180deg);}"]) : (0, _styledComponents.css)(["margin-left:auto;"]);
});
var StyledTableColumn = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledTableColumn",
  componentId: "sc-1qzqb4d-7"
})(["min-width:", ";min-height:200px;display:flex;flex-direction:column;align-items:center;", ""], function (_ref14) {
  var isMobile = _ref14.isMobile;
  return isMobile ? '140px' : '150px';
}, function (_ref15) {
  var highlight = _ref15.highlight;
  return highlight && (0, _styledComponents.css)(["background-color:rgba(248,231,28,0.2);"]);
});
var StyledHotelOfferButton = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffersSkeleton__StyledHotelOfferButton",
  componentId: "sc-1qzqb4d-8"
})(["width:calc(100% - 10px);margin-bottom:14px;height:48px;border-radius:var(--border-radius);", ""], function (_ref16) {
  var isActive = _ref16.isActive;
  return isActive ? (0, _styledComponents.css)(["background-color:var(--secondary);"]) : (0, _styledComponents.css)(["box-shadow:var(--box-shadow);"]);
});
var _default = exports["default"] = HotelRoomOffersSkeleton;